import { useState } from 'react';
import { signOut } from './signOut';

/** Shared busy guard for Sign out. Navigation always follows, so `busy` is never reset. */
export function useSignOut(): { busy: boolean; run: () => void } {
  const [busy, setBusy] = useState(false);

  function run() {
    if (busy) return;
    setBusy(true);
    void signOut();
  }

  return { busy, run };
}
